import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'


const AcademicServicesEle = () => {
    const calendarsData = [
        {
            cname: "Entitlement for availing Institute financial assistance ",
            url: 'https://files.iittp.ac.in/pdfs/downloads/Annexure-IITT_RO_F-15_2024-01-03.pdf',    
            glow: true,
        },
        {
            cname: "Charges for Academic Services",
            url: 'https://files.iittp.ac.in/pdfs/downloads/Academic_Services_Charges.pdf',    
            glow: false,
        },
        {
            cname: "Guidelines for Fee Refund",
            url: 'https://iittp.ac.in/fee-refund-guidelines',    
            glow: false,
        },
        {
            cname: "Accreditation of Programmes ",
            url: 'https://files.iittp.ac.in/pdfs/downloads/Accreditation%20of%20Programmes_6-9-2022.pdf',    
        },
        {
            cname: "English Language Proficiency ",
            url: 'https://files.iittp.ac.in/pdfs/downloads/English%20Language%20Proficiency_16-2-2023.pdf',    
        },
        {
            cname: "Transfer Certificate ",
            url: 'https://files.iittp.ac.in/pdfs/downloads/Transfer%20Certificate_16-2-2023.pdf',    
        },
        {
            cname: "Conversion of CGPA to Percentage ",
            url: 'https://files.iittp.ac.in/pdfs/downloads/Conversion%20of%20CGPA%20into%20Percentage_16-2-2023.pdf',    
        },
        {
            cname: "Leave rules for M.S/Ph.D Scholars ",
            url: 'https://files.iittp.ac.in/pdfs/downloads/Leave%20Rules_MS_PhD%20v1_16-2-2023.pdf',    
        },
        {
            cname: "Guidelines for BAP Course Proposal",
            url: 'https://files.iittp.ac.in/pdfs/downloads/Guidelines%20for%20BAP%20Course%20Proposal.pdf',
        }
        
    ];


    return (
            
            <Container>
            <Row className='my-5 services-box lin'>
                    <Col>
                    <h1 className='text-center'>Academic Services</h1>
                    <ul className='ms-4 mt-4 fs-5'>
                            {calendarsData.map((value, index) => {
                                return (
                                    <li className='c-lineheight3' key={index}>
                                        <i className="fas fa-file-pdf me-3 text-danger"></i>
                                        <Link to={value.url} target="_blank">
                                            <span className={value.glow ? 'glowing-text' : ''} >{value.cname}</span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </Col>
                </Row>
            </Container>
                     
     
    );
};


export default AcademicServicesEle;
